import { createFileRoute } from '@tanstack/react-router'

import { ReconciliationScreen } from './-components/reconciliation-screen.tsx'

export const Route = createFileRoute('/cs-tools/reconciliation')({
  component: ReconciliationScreen
})
